/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-no-bind */
import { Link as RouterLink } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import { Box, Link, Container, Typography, Divider } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// layouts
import Menu from '../components/Menu';
import ClientMenuLeft from './common/ClientMenuLeft';

// components
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function HomePage() {
  return (
    <RootStyle title="Comtel Bénin | Gestion des plaintes">
      <Menu />
      <ClientMenuLeft />
      <Container>
        <ContentStyle>
          <Box sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              Gestion des plaintes
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>
              Signaler un problème ou une préoccupation avec Comtel Bénin. Le traitement des
              réclamations des plaintes clients et fournisseurs est simple avec nous.
            </Typography>
          </Box>
          <Link underline="none" variant="subtitle2" component={RouterLink} to="/complaint">
            <LoadingButton fullWidth size="large" type="submit" variant="outlined">
              Déposer une plainte sans s’identifier
            </LoadingButton>{' '}
          </Link>
          <Divider sx={{ my: 3 }}>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              OU
            </Typography>
          </Divider>
          <Link underline="none" variant="subtitle2" component={RouterLink} to="/register">
            <LoadingButton fullWidth size="large" type="submit" variant="outlined">
              Déposer une plainte avec authentification
            </LoadingButton>{' '}
          </Link>
          <MHidden width="smUp">
            <Typography variant="subtitle2" sx={{ mt: 3, textAlign: 'center' }}>
              Already have an account?&nbsp;
              <Link to="/login" component={RouterLink}>
                Login
              </Link>
            </Typography>
          </MHidden>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
